import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import './ConcienciaMazeGame.css';

export const CELL_PATH = 0;
export const CELL_WALL = 1;
export const CELL_START = 2;
export const CELL_TARGET = 3;

const MAZE_TEMPLATES = {
  1: [
    [1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 1],
    [1, 1, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 3, 1],
    [1, 0, 1, 1, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1],
    [1, 1, 1, 1, 1, 1, 1]
  ],
  2: [
    [1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 3, 1],
    [1, 0, 1, 0, 0, 0, 1, 0, 1],
    [1, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1]
  ],
  3: [
    [1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 0, 1],
    [1, 0, 1, 0, 0, 0, 0, 0, 1],
    [1, 0, 0, 0, 1, 1, 1, 3, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1]
  ],
  4: [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1],
    [1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1],
    [1, 0, 1, 0, 1, 1, 1, 0, 1, 3, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
  ],
  5: [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 0, 1, 1, 1],
    [1, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 0, 1, 0, 1, 1, 1, 1, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 0, 0, 1, 3, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
  ],
  7: [
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    [2, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1],
    [1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1, 0, 1],
    [1, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 1],
    [1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 0, 1],
    [1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 1],
    [1, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1],
    [1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1],
    [1, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 3, 1],
    [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
  ]
};

const DIRECTIONS = {
  ArrowUp: { row: -1, col: 0 },
  w: { row: -1, col: 0 },
  W: { row: -1, col: 0 },
  ArrowDown: { row: 1, col: 0 },
  s: { row: 1, col: 0 },
  S: { row: 1, col: 0 },
  ArrowLeft: { row: 0, col: -1 },
  a: { row: 0, col: -1 },
  A: { row: 0, col: -1 },
  ArrowRight: { row: 0, col: 1 },
  d: { row: 0, col: 1 },
  D: { row: 0, col: 1 }
};

const CARDINAL_DIRECTIONS = [
  { row: -1, col: 0 },
  { row: 1, col: 0 },
  { row: 0, col: -1 },
  { row: 0, col: 1 }
];

function clampNumber(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function cloneGrid(grid) {
  return grid.map((row) => row.slice());
}

function findCell(maze, value) {
  for (let row = 0; row < maze.length; row += 1) {
    for (let col = 0; col < maze[row].length; col += 1) {
      if (maze[row][col] === value) return { row, col };
    }
  }
  return null;
}

function isValidPoint(grid, point) {
  return point && Number.isInteger(point.row) && Number.isInteger(point.col)
    && point.row >= 0 && point.row < grid.length
    && point.col >= 0 && point.col < grid[point.row].length;
}

function isOpenCell(maze, row, col) {
  return row >= 0 && row < maze.length && col >= 0 && col < maze[row].length && maze[row][col] !== CELL_WALL;
}

function normalizeRawGrid(rawGrid) {
  if (!Array.isArray(rawGrid) || rawGrid.length < 3 || rawGrid.length > 17) return null;
  if (!Array.isArray(rawGrid[0]) || rawGrid[0].length < 3 || rawGrid[0].length > 17) return null;
  const width = rawGrid[0].length;
  if (!rawGrid.every((row) => Array.isArray(row) && row.length === width)) return null;
  return rawGrid.map((row) => row.map((cell) => {
    const parsed = Number(cell);
    return [CELL_PATH, CELL_WALL, CELL_START, CELL_TARGET].includes(parsed) ? parsed : CELL_PATH;
  }));
}

export function hasMazePath(maze) {
  const start = findCell(maze, CELL_START);
  const target = findCell(maze, CELL_TARGET);
  if (!start || !target) return false;

  const queue = [start];
  const seen = new Set([start.row + ':' + start.col]);
  while (queue.length > 0) {
    const current = queue.shift();
    if (current.row === target.row && current.col === target.col) return true;
    CARDINAL_DIRECTIONS.forEach((delta) => {
      const next = { row: current.row + delta.row, col: current.col + delta.col };
      const key = next.row + ':' + next.col;
      if (!seen.has(key) && isOpenCell(maze, next.row, next.col)) {
        seen.add(key);
        queue.push(next);
      }
    });
  }
  return false;
}

export function normalizeMazeTemplate(input, fallbackDifficulty = 1) {
  const rawGrid = Array.isArray(input) ? input : input?.grid;
  const grid = normalizeRawGrid(rawGrid);
  if (!grid) return null;

  const startFromGrid = findCell(grid, CELL_START);
  const targetFromGrid = findCell(grid, CELL_TARGET);
  const start = isValidPoint(grid, input?.start) ? input.start : startFromGrid;
  const target = isValidPoint(grid, input?.target) ? input.target : targetFromGrid;
  if (!start || !target || grid[start.row][start.col] === CELL_WALL || grid[target.row][target.col] === CELL_WALL) return null;

  const taggedGrid = grid.map((row) => row.map((cell) => (cell === CELL_START || cell === CELL_TARGET ? CELL_PATH : cell)));
  taggedGrid[start.row][start.col] = CELL_START;
  taggedGrid[target.row][target.col] = CELL_TARGET;
  if (!hasMazePath(taggedGrid)) return null;

  return {
    grid: taggedGrid,
    start: { row: start.row, col: start.col },
    target: { row: target.row, col: target.col },
    difficulty: clampNumber(Number(input?.difficulty) || fallbackDifficulty || 1, 1, 7)
  };
}

export function createMazeTemplate(difficulty = 1) {
  const safeDifficulty = clampNumber(Math.round(Number(difficulty) || 1), 1, 7);
  return normalizeMazeTemplate({ grid: cloneGrid(MAZE_TEMPLATES[safeDifficulty] || MAZE_TEMPLATES[1]), difficulty: safeDifficulty }, safeDifficulty)
    || normalizeMazeTemplate({ grid: cloneGrid(MAZE_TEMPLATES[1]), difficulty: 1 }, 1);
}

export function getMazeDifficulty({ interactionCount = 0, lettersCount = 0 } = {}) {
  const raw = interactionCount >= 10 || lettersCount >= 3 ? 2 : 1;
  return Math.min(2, Math.max(1, raw));
}

export default function ConcienciaMazeGame({ difficulty = 1, mazeTemplate = null, mode = 'unlock', onComplete, onFail, t }) {
  const template = useMemo(() => normalizeMazeTemplate(mazeTemplate, difficulty) || createMazeTemplate(difficulty), [difficulty, mazeTemplate]);
  const maze = template.grid;
  const start = template.start;
  const target = template.target;
  const effectiveDifficulty = template.difficulty;
  const timeLimit = effectiveDifficulty >= 7 ? 60 : effectiveDifficulty >= 4 ? 45 : 30;
  const [position, setPosition] = useState(start);
  const [remaining, setRemaining] = useState(timeLimit);
  const [isExiting, setIsExiting] = useState(false);
  const boardRef = useRef(null);
  const lastPointerMoveRef = useRef(0);
  const completedRef = useRef(false);
  const startedAtRef = useRef(Date.now());

  const buildAttemptMeta = useCallback((result, remainingSeconds = remaining) => ({
    result,
    difficulty: effectiveDifficulty,
    durationSeconds: Math.max(0, Math.round((Date.now() - startedAtRef.current) / 1000)),
    remainingSeconds: Math.max(0, Number(remainingSeconds) || 0),
    grid: cloneGrid(maze),
    start: { ...start },
    target: { ...target }
  }), [effectiveDifficulty, maze, remaining, start, target]);

  useEffect(() => {
    completedRef.current = false;
    startedAtRef.current = Date.now();
    setIsExiting(false);
    setPosition(start);
    setRemaining(timeLimit);
  }, [start, timeLimit, template]);

  const tryMove = useCallback((delta) => {
    setPosition((current) => {
      if (completedRef.current) return current;
      const next = { row: current.row + delta.row, col: current.col + delta.col };
      if (!isOpenCell(maze, next.row, next.col)) return current;
      if (next.row === target.row && next.col === target.col) {
        completedRef.current = true;
        const meta = buildAttemptMeta('completed');
        window.setTimeout(() => onComplete?.(meta), 80);
      }
      return next;
    });
  }, [buildAttemptMeta, maze, onComplete, target]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemaining((value) => {
        if (completedRef.current) return value;
        if (value <= 1) {
          window.clearInterval(timer);
          completedRef.current = true;
          onFail?.('timeout', buildAttemptMeta('timeout', 0));
          return 0;
        }
        return value - 1;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, [buildAttemptMeta, onFail]);

  useEffect(() => {
    const onKeyDown = (event) => {
      const delta = DIRECTIONS[event.key];
      if (!delta) return;
      event.preventDefault();
      tryMove(delta);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [tryMove]);

  const moveTowardPointer = useCallback((clientX, clientY, immediate = false) => {
    const board = boardRef.current;
    if (!board || completedRef.current) return;
    const now = Date.now();
    if (!immediate && now - lastPointerMoveRef.current < 120) return;
    lastPointerMoveRef.current = now;

    const rect = board.getBoundingClientRect();
    const cellWidth = rect.width / maze[0].length;
    const cellHeight = rect.height / maze.length;
    const pointerCol = Math.floor((clientX - rect.left) / cellWidth);
    const pointerRow = Math.floor((clientY - rect.top) / cellHeight);
    const rowDiff = pointerRow - position.row;
    const colDiff = pointerCol - position.col;
    if (rowDiff === 0 && colDiff === 0) return;

    if (Math.abs(rowDiff) > Math.abs(colDiff)) {
      tryMove({ row: Math.sign(rowDiff), col: 0 });
    } else {
      tryMove({ row: 0, col: Math.sign(colDiff) });
    }
  }, [maze, position, tryMove]);

  const handlePointerDown = (event) => {
    event.currentTarget.setPointerCapture?.(event.pointerId);
    moveTowardPointer(event.clientX, event.clientY, true);
  };

  const handlePointerMove = (event) => {
    moveTowardPointer(event.clientX, event.clientY, event.buttons === 1);
  };

  const handleExitToLetter = () => {
    if (completedRef.current || isExiting) return;
    completedRef.current = true;
    setIsExiting(true);
    onFail?.('abandoned', buildAttemptMeta('abandoned'));
  };

  const isPractice = mode === 'replay' || mode === 'generated';
  const titleKey = mode === 'replay' ? 'mazeReplayTitle' : mode === 'generated' ? 'mazeGeneratedTitle' : 'mazeTitle';
  const bodyKey = isPractice ? 'mazePracticeBody' : 'mazeBody';
  const kickerKey = isPractice ? 'mazePracticeKicker' : 'mazeKicker';
  const exitKey = isPractice ? 'mazePracticeExit' : 'mazeExit';

  return (
    <section className={'conciencia-maze-shell' + (remaining <= 7 ? ' is-urgent' : '')} aria-live="polite">
      <div className="conciencia-maze-copy">
        <p className="conciencia-maze-kicker">{t('consciousness.' + kickerKey)}</p>
        <h2>{t('consciousness.' + titleKey)}</h2>
        <p>{t('consciousness.' + bodyKey)}</p>
        <div className="conciencia-maze-meta">
          <span className="conciencia-maze-timer">{t('consciousness.mazeTimer', { seconds: remaining })}</span>
          <span>{t('consciousness.mazeDifficulty', { level: effectiveDifficulty })}</span>
        </div>
      </div>

      <div
        ref={boardRef}
        className="conciencia-maze-board"
        style={{ '--maze-columns': maze[0].length, '--maze-rows': maze.length }}
        role="application"
        aria-label={t('consciousness.mazeAria')}
        tabIndex={0}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
      >
        {maze.flatMap((row, rowIndex) => row.map((cell, colIndex) => {
          const isMouse = position.row === rowIndex && position.col === colIndex;
          const isTarget = cell === CELL_TARGET;
          const isStart = cell === CELL_START;
          const className = [
            'conciencia-maze-cell',
            cell === CELL_WALL ? 'is-wall' : 'is-path',
            isTarget ? 'is-target' : '',
            isStart ? 'is-start' : ''
          ].filter(Boolean).join(' ');
          return (
            <div className={className} key={rowIndex + '-' + colIndex}>
              {isTarget && <span className="conciencia-maze-crate" aria-hidden="true">{'\u25A4'}</span>}
              {isMouse && <span className="conciencia-maze-mouse" aria-hidden="true">{'\u{1F42D}'}</span>}
            </div>
          );
        }))}
      </div>

      <div className="conciencia-maze-actions">
        <button type="button" className="regenerate-btn" onClick={handleExitToLetter} disabled={isExiting}>
          {isExiting ? t('consciousness.mazeExiting') : t('consciousness.' + exitKey)}
        </button>
      </div>
    </section>
  );
}
